import { render, staticRenderFns } from "./SummaryDetails.vue?vue&type=template&id=704611cf&scoped=true"
import script from "./SummaryDetails.vue?vue&type=script&lang=js"
export * from "./SummaryDetails.vue?vue&type=script&lang=js"
import style0 from "./SummaryDetails.vue?vue&type=style&index=0&id=704611cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704611cf",
  null
  
)

export default component.exports